import { Alert, Card, IconButton, Icons, Stack, styled, Typography } from '@healthinal/ui';
import { useRouter } from '@tanstack/react-router';
import { theme } from '../../theme.ts';
import { ErrorPresentation } from './errors.tsx';

type ErrorCardProps = ErrorPresentation & {
  eventId?: string;
};

export function ErrorCard({ title, description, details, actions, shouldBeReported, eventId }: ErrorCardProps) {
  const { history } = useRouter();
  return (
    <Stack alignItems="center" justifyContent="center" flex={1} maxHeight={800} gap={5}>
      <StyledCard variant="plain">
        <TopLeftIconButton size="sm" onClick={() => history.go(-1)}>
          <Icons.ArrowBack />
        </TopLeftIconButton>
        <Icons.ErrorOutline fontSize="large" color="error" />
        <Typography level="h3">{title}</Typography>
        <Typography level="body-md">{description}</Typography>
        {details && <Details>{details}</Details>}
        {actions}
      </StyledCard>
      {shouldBeReported && <Typography level="body-sm">Sentry ID: {eventId}</Typography>}
    </Stack>
  );
}

export function NotFoundCard() {
  return (
    <ErrorCard
      title="Seite nicht gefunden"
      description="Die angeforderte Seite wurde nicht gefunden."
      shouldBeReported={false}
    />
  );
}

const StyledCard = styled(Card)`
  padding: 48px;
  min-width: 360px;
  max-width: 560px;
  gap: 24px;
  box-shadow: ${theme.vars.shadow.xl};
  align-items: center;
`;

const TopLeftIconButton = styled(IconButton)`
  position: absolute;
  top: 16px;
  left: 16px;
`;

const Details = styled(Alert)`
  font-family: monospace;
  white-space: pre-line;
`;
